import { render, staticRenderFns } from "./OpportunityActivityItem.vue?vue&type=template&id=4d05a07c&scoped=true&"
import script from "./OpportunityActivityItem.vue?vue&type=script&lang=js&"
export * from "./OpportunityActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityActivityItem.vue?vue&type=style&index=0&id=4d05a07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05a07c",
  null
  
)

export default component.exports